// @file Entrypoint for auth login page
import { captureException } from 'bits/error_tracker'
import { ww } from 'bits/global'
import { setupVueApp } from 'bits/vue'
import AuthLoginApp from 'vuecomponents/AuthLoginApp.vue'
import { storeOptions } from 'vuexstore/landside'

void setupVueApp({
  el: '#auth_login_app',
  rootComponent: AuthLoginApp,
  storeOptions,
  initializeStore(store): void {
    store.dispatch('initializeState', ww.vueStartingState).catch(captureException)
  },
})
